(function (window, document) {
  'use strict';

  var installed = false;

  function localizedRoot() {
    var root = window.theme && window.theme.localizedRootUrl
      ? window.theme.localizedRootUrl
      : window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    root = String(root || '/');
    if (root.charAt(0) !== '/') root = '/' + root;
    return root.replace(/\/?$/, '/');
  }

  function cartUrl(url) {
    if (typeof url !== 'string' || url.indexOf('/cart') !== 0) return url;
    var root = localizedRoot();
    if (root === '/') return url;
    return root.replace(/\/$/, '') + url;
  }

  window.MerlonsLocalizedRoutes = {
    root: localizedRoot,
    cart: cartUrl
  };

  function installJqueryCartRouteGuard() {
    if (installed || !window.jQuery || !window.jQuery.ajaxPrefilter) return;
    window.jQuery.ajaxPrefilter(function (options) {
      options.url = cartUrl(options.url);
    });
    installed = true;
  }

  installJqueryCartRouteGuard();
  if (!installed) {
    document.addEventListener('DOMContentLoaded', installJqueryCartRouteGuard, { once: true });
  }
})(window, document);
